// extracted by mini-css-extract-plugin
module.exports = {"departments":"Jh-z","departmentHeading":"Kh-z","departmentSection":"Lh-z","departmentName":"Mh-z","departmentLink":"Nh-z","expandIcon":"Oh-z"};